import React from "react";

import connection from "../../../connection";
import GestaoFormacao from "./gestao";
import VisualizacaoFormacao from "./visualizacao";

import withStyles from "@material-ui/core/styles/withStyles";
import formacoesStyle from "assets/jss/material-dashboard-pro-react/views/formacoesStyle";

class PaginaFormacao extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formacao: null
    };

    let id = props.id_formacao || props.location.pathname.split("/formacao/")[1];

    this.reloadInformacoesFormacao = async () => {
      let id = this.props.id_formacao || this.props.location.pathname.split("/formacao/")[1];
      let formacao = await connection.get("formacao/detalhes", {id_formacao: id});

      this.setState({formacao: formacao})
    };
  }

  componentDidMount() {
    this.reloadInformacoesFormacao();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let id = this.props.id_formacao || this.props.location.pathname.split("/formacao/")[1];
    let id_prev = prevProps.id_formacao || prevProps.location.pathname.split("/formacao/")[1];

    if (id_prev !== id) {
      this.reloadInformacoesFormacao();
    }
  }

  render() {
    if (!this.state.formacao)
      return "A carregar...";
    if (this.state.formacao.pagina_gestao && !this.props.visualizacao)
      return <GestaoFormacao detalhes={this.state.formacao} reloadDetalhes={this.reloadInformacoesFormacao}/>;
    return <VisualizacaoFormacao detalhes={this.state.formacao} reloadDetalhes={this.reloadInformacoesFormacao}/>;
  }
}

export default withStyles(formacoesStyle)(PaginaFormacao);
